// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width: 64rem){.EcommerceConnectDialog-dialogContent__YCUVv{width:560px}}.EcommerceConnectDialog-form__RDWON{display:flex;flex:1;flex-direction:column;min-height:0}.EcommerceConnectDialog-body__eTBoO{display:flex;flex-direction:column;gap:var(--size-4);padding:var(--size-4)}.EcommerceConnectDialog-scopesList__LQgnl{margin:var(--size-1) 0 0;padding-left:var(--size-5);list-style:disc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogContent": "EcommerceConnectDialog-dialogContent__YCUVv",
	"form": "EcommerceConnectDialog-form__RDWON",
	"body": "EcommerceConnectDialog-body__eTBoO",
	"scopesList": "EcommerceConnectDialog-scopesList__LQgnl"
};
export default ___CSS_LOADER_EXPORT___;
